import { render, staticRenderFns } from "./WizardContentView.vue?vue&type=template&id=18076822&scoped=true&"
import script from "./WizardContentView.vue?vue&type=script&lang=ts&"
export * from "./WizardContentView.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentView.vue?vue&type=style&index=0&id=18076822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18076822",
  null
  
)

export default component.exports